import type { CustomerInfoVO } from '@/services/ant-design-pro/typings';

export type BatchMode = 'uniform' | 'excel' | 'rules';

export type ScenarioKey = 'autoAudit' | 'valuation' | 'ourContact' | 'customerContact';

export type FailedItem = {
  customerId: string | number;
  reason?: string;
  sourceRow?: Record<string, unknown>;
};

export type BatchScenarioPanelHandle = {
  /** 提交当前场景；返回是否应关闭弹窗 */
  submit: () => Promise<boolean>;
};

export type BatchScenarioPanelProps = {
  customers: CustomerInfoVO[];
  /** 场景是否处于激活态（用于重置） */
  active: boolean;
  onDirty: () => void;
  onFooterChange: (state: { showOk: boolean; submitting: boolean }) => void;
};

export const SWITCH_OPTIONS = [
  { label: '开启', value: true },
  { label: '关闭', value: false },
];

export function filterValidCustomers(customers: CustomerInfoVO[]) {
  return customers.filter(
    (customer) => customer.id !== undefined && customer.id !== null,
  );
}
